import React, { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
const ConnectAccountModal = dynamic(() => import("../components/presentational/tailwind/ConnectAccountModal"), { ssr: false });
const UpgradeModal = dynamic(() => import("../components/presentational/tailwind/UpgradeModal"), { ssr: false });

const ModalContext = React.createContext(null)
ModalContext.displayName = 'ModalContext';
export const useModalContext = () => React.useContext(ModalContext) || {};

export default function ModalContextProvider({ children }) {
    const [isConnectAccountModalOpened, setIsConnectAccountModalOpened] = React.useState(false);
    const [isUpgradeModalOpened, setIsUpgradeModalOpened] = React.useState(false);
    const [isConnectAccountModalLoaded, setIsConnectAccountModalLoaded] = useState(false);
    const [isUpgradeModalLoaded, setIsUpgradeModalLoaded] = useState(false);

    useEffect(() => {
        const loadModals = () => {
            setIsConnectAccountModalLoaded(true);
            setIsUpgradeModalLoaded(true);
        };

        'requestIdleCallback' in window
            ? window.requestIdleCallback(loadModals)
            : setTimeout(loadModals, 1);
    }, []);

    const value = {
        setIsConnectAccountModalOpened,
        setIsUpgradeModalOpened
    };

    return <ModalContext.Provider value={value}>
        {children}
        {isConnectAccountModalLoaded && <ConnectAccountModal isOpen={isConnectAccountModalOpened} onClose={() => { setIsConnectAccountModalOpened(false); }} />}
        {isUpgradeModalLoaded && <UpgradeModal isOpen={isUpgradeModalOpened} onClose={() => { setIsUpgradeModalOpened(false); }} />}
    </ModalContext.Provider>
}